import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { ModalService } from 'app/core/services/modal.service';
import { ThemeService } from 'app/core/services/theme.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ItemEditorGuard implements CanActivate {
  constructor(private themeService: ThemeService, private modalService: ModalService, private router: Router) {}

  canActivate(
    _: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.themeService.theme.pipe(
      map(theme => {
        // This config prevents Angular's router to mess with the route/URL state
        // when we cancel the navigation to `/editor/add-to-order`
        // inside the Guard in order to show the editor modal
        // More info: https://github.com/angular/angular/issues/13586
        this.router.canceledNavigationResolution = 'computed';
        let itemId: number;

        if (state.url.includes('/item/')) {
          itemId = parseInt(state.url.split('item/')[1], 10);
        }
        if (theme.showItemEditorModal) {
          this.modalService.openItemEditorModal(!isNaN(itemId) ? itemId : null);
        }
        return theme.showItemEditorModal ? false : true;
      })
    );
  }
}
